import React, { useState } from 'react';

const faqs = [
  {
    question: 'Werkt Pactorae voor zowel België als Nederland?',
    answer: 'Ja, Pactorae is specifiek ontworpen voor freelancers en ZZP\'ers in zowel België als Nederland. De generator houdt rekening met de specifieke juridische vereisten van beide landen, inclusief het ondernemingsnummer en btw-nummer voor België, en het KvK-nummer voor Nederland.',
  },
  {
    question: 'Wat is het verschil tussen Belgisch en Nederlands contractrecht?',
    answer: 'Hoewel beide landen een vergelijkbaar rechtssysteem hebben, zijn er belangrijke verschillen. In België is het Burgerlijk Wetboek van toepassing, terwijl in Nederland het Burgerlijk Wetboek (BW) geldt. Betalingstermijnen, aansprakelijkheidsregels en de vereisten voor een geldig contract kunnen verschillen. Pactorae genereert automatisch het juiste contract op basis van jouw land.',
  },
  {
    question: 'Kan ik contracten in beide talen maken?',
    answer: 'Ja, Pactorae ondersteunt het Nederlands voor beide markten. Contracten worden opgesteld in het Nederlands, wat de standaardtaal is voor zakelijke overeenkomsten in zowel België als Nederland. Voor internationale opdrachten kan een Engelstalige versie worden gegenereerd.',
  },
  {
    question: 'Is Pactorae gratis?',
    answer: 'Ja, je kunt gratis een professioneel freelance contract genereren via Pactorae. De basisgenerator is volledig gratis beschikbaar voor freelancers en ZZP\'ers in de Benelux. Er zijn geen verborgen kosten of abonnementsverplichtingen.',
  },
  {
    question: 'Welke contracttypes zijn beschikbaar voor de Benelux?',
    answer: 'Pactorae biedt de volgende contracttypes aan voor de Benelux: freelance overeenkomst, NDA (geheimhoudingsverklaring), algemene voorwaarden en consultancy overeenkomst. Elk contract wordt op maat gemaakt voor jouw specifieke situatie en het gekozen land.',
  },
];

const FaqItem = ({ faq }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none"
        aria-expanded={open}
      >
        <span className="text-base font-semibold text-[#2F4E6F] pr-4">{faq?.question}</span>
        <span
          className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-transform duration-200"
          style={{ backgroundColor: '#FF8C00', transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <p className="text-gray-600 leading-relaxed">{faq?.answer}</p>
        </div>
      )}
    </div>
  );
};

const BeneluxFaq = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Veelgestelde vragen over de Benelux contract generator</h2>
    <div className="space-y-3">
      {faqs?.map((faq, i) => (
        <FaqItem key={i} faq={faq} />
      ))}
    </div>
  </section>
);

export default BeneluxFaq;
